import axiosInstance from '@/services'
import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'

const checkIfSponsoredHasEscapeReport = async () => {
  const formStore = useFormStore()
  const { referenceRequestNumber } = formStore.form.values || {}
  if (referenceRequestNumber === undefined) {
    const formData = formStore.draft || formStore.form.values
    const { personUnifiedNumber, passportNumber, passportTypeId, currentNationalityId } = formData
    const payload = { personUnifiedNumber, passportNumber, passportTypeId, currentNationalityId }
    const res = await axiosInstance.post(
      '/api/establishment/checkIfSponsoredHasEscapeReport',
      payload
    )

    return res
  }
}

export default async function () {
  const globalStore = useGlobalStore()
  const res = await checkIfSponsoredHasEscapeReport()
  if (!res) return true

  globalStore.$patch({
    confirmConfig: {
      title: 'informativeMsg',
      message: 'notifyEstablishmentIfSponsoredHasEscapeReport'
    },
    confirmShown: true
  })

  return new Promise((resolve) => {
    globalStore.$subscribe((__, { confirmResponse }) => resolve(confirmResponse))
  })
}
